import React from 'react';
import { Accordion, Carousel } from 'react-bootstrap';

import wte1 from '../../_assets/images/journey/01-what-to-expect.png';
import wte2 from '../../_assets/images/journey/02-what-to-expect.png';
import wte3 from '../../_assets/images/journey/03-what-to-expect.png';
import wte4 from '../../_assets/images/journey/04-what-to-expect.png';
import wte5 from '../../_assets/images/journey/05-what-to-expect.png';
import wte6 from '../../_assets/images/journey/06-what-to-expect.png';

export const WhatToExpect = () => {
    const element = (
        <Accordion className="journey-accordion mb-4">
            <Accordion.Item eventKey="0">
                <Accordion.Header>
                    What To Expect
                </Accordion.Header>
                <Accordion.Body>
                    <Carousel indicators={false} interval={null}>
                        <Carousel.Item>
                            <img src={wte1} className="d-block" />
                            <Carousel.Caption>
                                <div className="carousel-cont1">
                                    <div className="carousel-circle"><b>1</b></div>
                                </div>
                                <div className="carousel-cont2">
                                    <div className="desc">
                                        <b>After your appointment is Booked</b>
                                        <p>Look for an email confirmation, remember to save the date.</p>
                                    </div>
                                </div>
                            </Carousel.Caption>
                        </Carousel.Item>

                        <Carousel.Item>
                            <img src={wte2} className="d-block" />
                            <Carousel.Caption>
                                <div className="carousel-cont1">
                                    <div className="carousel-circle"><b>2</b></div>
                                </div>
                                <div className="carousel-cont2">
                                    <div className="desc">
                                        <b>Confirm Your Appointment via Text</b>
                                        <p>Check your phone for text reminders and confirm your appointment.</p>
                                    </div>
                                </div>
                            </Carousel.Caption>
                        </Carousel.Item>

                        <Carousel.Item>
                            <img src={wte3} className="d-block" />
                            <Carousel.Caption>
                                <div className="carousel-cont1">
                                    <div className="carousel-circle"><b>3</b></div>
                                </div>
                                <div className="carousel-cont2">
                                    <div className="desc">
                                        <b>Tell Us About Your Pet</b>
                                        <p>Help us customize your visit by filling out your pet&apos;s intake form. It takes less than 2 minutes. Prior to your appointment, we will email/text you the intake form so we can be prepared for your pet&apos;s visit.</p>
                                    </div>
                                </div>
                            </Carousel.Caption>
                        </Carousel.Item>

                        <Carousel.Item>
                            <img src={wte4} className="d-block" />
                            <Carousel.Caption>
                                <div className="carousel-cont1">
                                    <div className="carousel-circle"><b>4</b></div>
                                </div>
                                <div className="carousel-cont2">
                                    <div className="desc">
                                        <b>Check-in</b>
                                        <p>Listen for our call so we can discuss your pet&apos;s needs in advance. Our team will call you when it&apos;s your turn.</p>
                                    </div>
                                </div>
                            </Carousel.Caption>
                        </Carousel.Item>

                        <Carousel.Item>
                            <img src={wte5} className="d-block" />
                            <Carousel.Caption>
                                <div className="carousel-cont1">
                                    <div className="carousel-circle"><b>5</b></div>
                                </div>
                                <div className="carousel-cont2">
                                    <div className="desc">
                                        <b>See the Vet</b>
                                        <p>Come inside with your pet. One person per pet, please.</p>
                                    </div>
                                </div>
                            </Carousel.Caption>
                        </Carousel.Item>

                        <Carousel.Item>
                            <img src={wte6} className="d-block" />
                            <Carousel.Caption>
                                <div className="carousel-cont1">
                                    <div className="carousel-circle"><b>6</b></div>
                                </div>
                                <div className="carousel-cont2">
                                    <div className="desc">
                                        <b>Check-out</b>
                                        <p>Your visit is complete. When you get home, look for an email with your pet&apos;s medical documents and important information from today&apos;s visit.</p>
                                    </div>
                                </div>
                            </Carousel.Caption>
                        </Carousel.Item>
                    </Carousel>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );

    return element;
};
